import { render, staticRenderFns } from "./SanctionDetails.vue?vue&type=template&id=1b7e8616&scoped=true"
import script from "./SanctionDetails.vue?vue&type=script&lang=js"
export * from "./SanctionDetails.vue?vue&type=script&lang=js"
import style0 from "./SanctionDetails.vue?vue&type=style&index=0&id=1b7e8616&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7e8616",
  null
  
)

export default component.exports